"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7232],{

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 61467:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/External_Data_Solutions.4d134abd.svg","height":506,"width":588});

/***/ }),

/***/ 5659:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Featured1.fe8e6ccc.svg","height":56,"width":56});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 33911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96});

/***/ }),

/***/ 8869:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Clearco.46288e58.svg","height":25,"width":119});

/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82});

/***/ }),

/***/ 68197:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Openly.36908f71.svg","height":45,"width":71});

/***/ }),

/***/ 86051:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111});

/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 43260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ DataApi; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/components/MainCtaButton.jsx
var MainCtaButton = __webpack_require__(11723);
// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingCustomers.jsx
var LandingCustomers = __webpack_require__(59666);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/NoCodeDeployment.svg
/* harmony default export */ var NoCodeDeployment = ({"src":"/_next/static/media/NoCodeDeployment.262b8fc1.svg","height":304,"width":744});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/RestfulDeployment.svg
/* harmony default export */ var RestfulDeployment = ({"src":"/_next/static/media/RestfulDeployment.1c488e8e.svg","height":454,"width":684});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/SimpleDeployment.svg
/* harmony default export */ var SimpleDeployment = ({"src":"/_next/static/media/SimpleDeployment.d7bb9b4f.svg","height":448,"width":870});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/FrictionlessDeployment.svg
/* harmony default export */ var FrictionlessDeployment = ({"src":"/_next/static/media/FrictionlessDeployment.375d3e47.svg","height":454,"width":684});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/CentralizeManagement.svg
/* harmony default export */ var CentralizeManagement = ({"src":"/_next/static/media/CentralizeManagement.f493848b.svg","height":303,"width":457});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/DeploymentManagement.svg
/* harmony default export */ var DeploymentManagement = ({"src":"/_next/static/media/DeploymentManagement.38e3126b.svg","height":399,"width":790});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/DataApi/LifecycleManagement.svg
/* harmony default export */ var LifecycleManagement = ({"src":"/_next/static/media/LifecycleManagement.9f21acf4.svg","height":450,"width":714});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Clearco.svg
var Clearco = __webpack_require__(8869);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Openly.svg
var Openly = __webpack_require__(68197);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
// EXTERNAL MODULE: ./src/landingPage/views/HomePage/assets/icons/Featured1.svg
var Featured1 = __webpack_require__(5659);
// EXTERNAL MODULE: ./src/landingPage/views/HomePage/assets/External_Data_Solutions.svg
var External_Data_Solutions = __webpack_require__(61467);
;// CONCATENATED MODULE: ./src/landingPage/views/DataApi/DataApi.jsx


















var DataApi = function(param) {
    var keyword = param.keyword;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var data = {
        "centralize-management": {
            heroData: {
                title: "Centrally Manage All Third Party Data",
                subtitle: "Centrally manage all your third party data APIs with the Demyst platform and reduce security risks, improve performance and unlock value at scale within your organization.",
                image: CentralizeManagement.src,
                image_alt: "diagram demonstrating a Demyst third party data central management capabilities"
            }
        },
        "deployment-management": {
            heroData: {
                title: "One Platform To Manage API Deployments",
                subtitle: "Centrally manage all your third party data API deployments with the Demyst platform to reduce security risks, improve performance and unlock value at scale within your organization.",
                image: DeploymentManagement.src,
                image_alt: "diagram demonstrating a Demyst third party data deployment management capabilities"
            }
        },
        "frictionless-deployment": {
            heroData: {
                title: "Frictionless Deployment of Data APIs",
                subtitle: "Easily deploy external data APIs to power core application within your organization. Create an account and deploy your first API in minutes within our platform.",
                image: FrictionlessDeployment.src,
                image_alt: "diagram symbolizing a Demyst API frictionless deployment"
            }
        },
        "lifecycle-management": {
            heroData: {
                title: "End-to-end Data API Lifecycle Management",
                subtitle: "Easily build, consume and manage HTTP APIs that provide the external data you need to power core applications.",
                image: LifecycleManagement.src,
                image_alt: "diagram demonstrating a Demyst third party data lifecycle management capabilities"
            }
        },
        "no-code-deployment": {
            heroData: {
                title: "No Code Deployment of Data APIs",
                subtitle: "Deploy third party data in minutes with our no-code deployment platform. Why spend weeks building third party data API when you can unlock the same potential in minutes? See Demyst in action for free today.",
                image: NoCodeDeployment.src,
                image_alt: "diagram symbolizing a Demyst API no code deployment"
            },
            valueSectionData: {
                title: "The power of no code data deployment",
                items: [
                    {
                        heading: "Empower your business users",
                        paragraph: "No code approach to third party data allow your business users to quickly demonstrate lift and identify what data will deliver value to your organization."
                    },
                    {
                        heading: "Free your technical team",
                        paragraph: "Allow your technical team to focus on building applications and functions that truly matter to your business. Our platform takes care of setting up the foundations to allow your team to build great products."
                    },
                    {
                        heading: "Deliver value at scale",
                        paragraph: "No code, no bottleneck. Truly democratize third party data within your organization and super charge innovation within every team."
                    }, 
                ]
            }
        },
        "restful-deployment": {
            heroData: {
                title: "Deploying HTTP APIs from the Demyst Platform",
                subtitle: "Easily deploy HTTPs APIs that provide the external data and customised logic you need to power core applications, data workflows or pull directly into your CRM.",
                image: RestfulDeployment.src,
                image_alt: "diagram symbolizing a Demyst API restful deployment"
            }
        },
        "simple-deployment": {
            heroData: {
                title: "Deploy a Data API With Ease",
                subtitle: "Access third party data in minutes with a streamlined data deployment platform. In just a few minutes, you can deploy a data API to the data source of your choosing.",
                image: SimpleDeployment.src,
                image_alt: "diagram demonstrating a Demyst API simple deployment workflow"
            }
        },
        landingCustomersData: {
            fields: {
                subheadline: "Join the customers already unlocking the power of third party data with Demyst:",
                logos: [
                    {
                        image: Farmers/* default.src */.Z.src,
                        image_alt: "Farmers Insurance"
                    },
                    {
                        image: Anz/* default.src */.Z.src,
                        image_alt: "ANZ"
                    },
                    {
                        image: StandardChartered/* default.src */.Z.src,
                        image_alt: "Standard Chartered"
                    },
                    {
                        image: Openly/* default.src */.Z.src,
                        image_alt: "Openly"
                    },
                    {
                        image: Clearco/* default.src */.Z.src,
                        image_alt: "Clearco (formerly Clearbank)"
                    }, 
                ]
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (0,clsx_m/* default */.Z)("LandingHero-background", "LandingHero-background-purple"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("LandingHero", "LandingHero-align-center"),
                    id: "hero",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "section-layout",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "LandingHero-title",
                                children: (ref = data[keyword]) === null || ref === void 0 ? void 0 : (ref1 = ref.heroData) === null || ref1 === void 0 ? void 0 : ref1.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "LandingHero-subtitle",
                                children: (ref2 = data[keyword]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.heroData) === null || ref3 === void 0 ? void 0 : ref3.subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "LandingCtas",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCtaButton/* MainCtaButton */.T, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (0,clsx_m/* default */.Z)("LandingHero-image", "noRadius", keyword === "centralize-management" && "centralizeManagement"),
                                src: (ref4 = data[keyword]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.heroData) === null || ref5 === void 0 ? void 0 : ref5.image,
                                alt: (ref6 = data[keyword]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.heroData) === null || ref7 === void 0 ? void 0 : ref7.image_alt,
                                loading: "eager"
                            })
                        ]
                    })
                })
            }),
            ((ref8 = data[keyword]) === null || ref8 === void 0 ? void 0 : ref8.valueSectionData) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("LandingMainContent", "LandingMainContent-background-gray-2", "LandingMainContent-align-left", "LandingMainContent-text_image", "Campaign"),
                id: "api-deployment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "section-layout",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("LandingTextImageContent-col", "LandingTextImageContent-col-text", "LandingTextImageContent-col-text-position-left"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: (ref9 = data[keyword]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.valueSectionData) === null || ref10 === void 0 ? void 0 : ref10.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "LandingTextImageContent-customUl2",
                                    children: (ref11 = data[keyword]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.valueSectionData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.items) === null || ref13 === void 0 ? void 0 : ref13.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: Featured1/* default.src */.Z.src,
                                                    alt: "",
                                                    width: "48",
                                                    height: "48",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: item === null || item === void 0 ? void 0 : item.heading
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: item === null || item === void 0 ? void 0 : item.paragraph
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item === null || item === void 0 ? void 0 : item.heading);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "LandingTextImageContent-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: External_Data_Solutions/* default.src */.Z.src,
                                alt: "",
                                loading: "lazy",
                                width: "588",
                                height: "506"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("LandingMainContent", "LandingMainContent-background-blue", "LandingMainContent-align-center", "LandingMainContent-customers", "Campaign"),
                id: "customers",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCustomers/* LandingCustomers */.l, {
                    data: data === null || data === void 0 ? void 0 : data.landingCustomersData
                })
            })
        ]
    });
};


/***/ }),

/***/ 49570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ LandingButterLink; }
/* harmony export */ });
/* unused harmony export onLandingButterLinkClick */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67474);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84135);







var onLandingButterLinkClick = function(e, pathname, section) {
    var target = e === null || e === void 0 ? void 0 : e.target;
    (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_1__/* .sendGaEvent */ .k8)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        action: "Button Click",
        category: "SEO"
    }, target && {
        label: "".concat(target === null || target === void 0 ? void 0 : target.innerText.slice(0, 10), " - ").concat(section ? "".concat(section.slice(0, 10), " - ") : " ").concat(pathname)
    }));
    return false;
};
var LandingButterLink = function(param) {
    var url = param.url, className = param.className, _external = param.external, external = _external === void 0 ? false : _external, section = param.section, children = param.children, demystIcon = param.demystIcon, variant = param.variant, size = param.size, onClick = param.onClick, _noStyle = param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, mainCTA = param.mainCTA;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var pathname = router.asPath;
    var sanitizeButterUrl = function(url) {
        var isValidHttpUrl = function(string) {
            var jsUrl;
            try {
                jsUrl = new URL(string);
            } catch (e) {
                return false;
            }
            return jsUrl.protocol === "http:" || jsUrl.protocol === "https:";
        };
        if (isValidHttpUrl(url)) return {
            target: "_blank",
            rel: "noreferrer noopener",
            to: new URL(url)
        };
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            to: url.endsWith("/") ? url.slice(0, -1) : url
        }, external === true && {
            isExternal: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_3__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sanitizeButterUrl(url)), {
        className: className,
        onClick: function(event) {
            onLandingButterLinkClick(event, pathname, section);
            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(onClick, Function) && onClick();
        },
        demystIcon: demystIcon,
        size: size,
        variant: variant,
        noStyle: noStyle,
        mainCTA: mainCTA,
        children: children
    }));
};


/***/ }),

/***/ 93022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LandingCtas; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _LandingButterLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49570);



var LandingCtas = function(param) {
    var ctas = param.ctas;
    if (!ctas) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "LandingCtas",
        children: ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingButterLink__WEBPACK_IMPORTED_MODULE_1__/* .LandingButterLink */ .v, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("LandingCtas-button", (cta === null || cta === void 0 ? void 0 : cta.button_variant) && "LandingCtas-button-".concat(cta === null || cta === void 0 ? void 0 : cta.button_variant)),
                variant: cta === null || cta === void 0 ? void 0 : cta.button_variant,
                demystIcon: (cta === null || cta === void 0 ? void 0 : cta.show_button_logo) === true,
                url: cta === null || cta === void 0 ? void 0 : cta.button_url,
                section: cta === null || cta === void 0 ? void 0 : cta.section,
                size: cta === null || cta === void 0 ? void 0 : cta.button_size,
                onClick: cta === null || cta === void 0 ? void 0 : cta.onClick,
                mainCTA: cta === null || cta === void 0 ? void 0 : cta.mainCTA,
                children: cta === null || cta === void 0 ? void 0 : cta.button_label
            }, cta);
        })
    });
};


/***/ }),

/***/ 59666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ LandingCustomers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LandingCtas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93022);


var LandingCustomers = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "section-layout",
        children: [
            (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.headline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.headline
            }),
            (data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.subheadline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.subheadline
            }),
            (data === null || data === void 0 ? void 0 : (ref4 = data.fields) === null || ref4 === void 0 ? void 0 : ref4.logos) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "LandingCustomers",
                children: data === null || data === void 0 ? void 0 : (ref5 = data.fields) === null || ref5 === void 0 ? void 0 : ref5.logos.map(function(logo) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: logo.image,
                        alt: logo.image_alt,
                        loading: "lazy"
                    }, logo);
                })
            }),
            (data === null || data === void 0 ? void 0 : (ref6 = data.fields) === null || ref6 === void 0 ? void 0 : ref6.ctas) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingCtas__WEBPACK_IMPORTED_MODULE_1__/* .LandingCtas */ .f, {
                ctas: data === null || data === void 0 ? void 0 : (ref7 = data.fields) === null || ref7 === void 0 ? void 0 : ref7.ctas
            })
        ]
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

}]);